import { formatLocalDateValue, formatLocalTime } from '@/libs/date/localDate';

export const formatInterviewSchedule = (
  startAt?: string | null,
  durationMinutes?: number | null,
) => {
  if (!startAt) return null;

  const start = new Date(startAt);
  if (Number.isNaN(start.getTime())) return null;

  const end = new Date(start.getTime() + (durationMinutes ?? 0) * 60_000);

  return {
    date: formatLocalDateValue(start),
    timeRange: durationMinutes
      ? `${formatLocalTime(start)}~${formatLocalTime(end)}`
      : formatLocalTime(start),
  };
};

export const formatInterviewRound = (round?: string | null) => {
  if (!round) return 'N/A';
  const numberedRound = round.match(/^Round\s+(\d+)$/i);
  return numberedRound ? `R${numberedRound[1]}` : round;
};

export type InterviewRoundResult = 'PASSED' | 'FAILED' | null | undefined;

export const getInterviewRoundBadgeClass = (result: InterviewRoundResult) => {
  if (result === 'PASSED') {
    return 'border-success/30 bg-success-muted text-success-muted-foreground';
  }

  if (result === 'FAILED') {
    return 'border-error/30 bg-error-muted text-error-muted-foreground';
  }

  return 'border-border-subtle bg-bg-main text-text-subtle';
};

export const getInterviewDay = (startAt?: string | null) => {
  if (!startAt) return '';

  const date = new Date(startAt);
  if (Number.isNaN(date.getTime())) return '';

  return formatLocalDateValue(date);
};

export const getInterviewRoundRank = (round?: string | null): number => {
  if (!round) return 0;
  if (/final/i.test(round)) return Number.MAX_SAFE_INTEGER;
  return Number(round.match(/\d+/)?.[0] ?? 0);
};
